import React, { useState, useMemo } from 'react'
import Breadcrumbs from '../../../../components/Common/Breadcrumb'
import {
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap"
import HtmlHead from '../../../../components/HtmlHead/HtmlHead'
import { payoutFeeInfoSections } from './payoutFeeInfoPdfText'
import { Table } from 'react-bootstrap'
import NoData from '../../../../components/NoData/NoData'

const normalize = (value) => String(value || "").trim();

const PayoutCommissionInformation = () => {

  const title = "Payout Commission Information"
  const description = ""

  const [query, setQuery] = useState("");

  const filteredSections = useMemo(() => {
    const q = normalize(query).toLowerCase();
    if (!q) return payoutFeeInfoSections;

    return payoutFeeInfoSections
      .map((section) => {
        const countries = section.countries
          .map((c) => {
            const entries = c.entries.filter((e) => {
              const haystack = [
                section.region,
                c.country,
                e.currency,
                e.supportMethod,
                e.receivingEntityType,
                e.settlementCharge,
                e.transferLimit,
                section.bankSettlementSupportCapabilities,
              ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();
              return haystack.includes(q);
            });
            return entries.length ? { ...c, entries } : null;
          })
          .filter(Boolean);

        return countries.length ? { ...section, countries } : null;
      })
      .filter(Boolean);
  }, [query]);

  const totalRows = useMemo(() => {
    return filteredSections.reduce((sum, s) => {
      return (
        sum +
        s.countries.reduce((cSum, c) => cSum + (c.entries?.length || 0), 0)
      );
    }, 0);
  }, [filteredSections]);

  const getSectionRowSpan = (section) =>
    section.countries.reduce((sum, c) => sum + c.entries.length, 0);

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <div className="container-fluid">
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Payout Commission Information"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div>
                    <div className="table-responsiv">

                      <div className="d-flex align-items-center justify-content-between mb-3 gap-2 flex-wrap">

                        <input
                          className="form-control"
                          type="search"
                          style={{ maxWidth: 420 }}
                          placeholder="Search (region, country, currency, charge, limit...)"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                        />
                        <div className="text-muted">
                          <span>
                            Rows: <b>{totalRows}</b>
                          </span>
                        </div>
                      </div>

                      {totalRows === 0 ? (
                        <div>
                          <NoData width={200} height={200} />
                          <p className="text-center text-muted mt-2">
                            <b> No data found matching your search query.</b>
                          </p>
                        </div>
                      ) : (
                        <div style={{ maxHeight: "60vh", overflow: "auto" }}>
                          <Table
                            bordered
                            responsive
                            className="mb-0 payout-commission-information-table"
                          >
                            <thead>
                              <tr>
                                <th className="text-nowrap" style={{ minWidth: 120 }}>Region</th>
                                <th className="text-nowrap" style={{ minWidth: 160 }}>Country</th>
                                <th className="text-nowrap" style={{ width: 90 }}>Currency</th>
                                <th className="text-nowrap" style={{ width: 130 }}>
                                  Support Method
                                </th>
                                <th className="text-nowrap" style={{ minWidth: 190 }}>
                                  Receiving Entity (Type)
                                </th>
                                <th className="text-nowrap" style={{ minWidth: 170 }}>
                                  Settlement Charge
                                </th>
                                <th className="text-nowrap" style={{ minWidth: 220 }}>
                                  Transfer Limit
                                </th>
                                <th className="text-nowrap" style={{ minWidth: 260 }}>
                                  Bank Settlement Support Capabilities
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredSections.map((section, sectionIdx) => {
                                const sectionRowSpan = getSectionRowSpan(section);

                                return section.countries.map((country, countryIdx) => {
                                  const countryRowSpan = country.entries.length;

                                  return country.entries.map((e, entryIdx) => {
                                    const key = `${section.region}-${country.country}-${e.currency}-${e.supportMethod}-${sectionIdx}-${countryIdx}-${entryIdx}`;

                                    return (
                                      <tr key={key}>
                                        {countryIdx === 0 && entryIdx === 0 ? (
                                          <td
                                            rowSpan={sectionRowSpan}
                                            style={{ verticalAlign: "middle", fontWeight: "500" }}
                                          >
                                            {section.region || "-"}
                                          </td>
                                        ) : null}

                                        {entryIdx === 0 ? (
                                          <td
                                            rowSpan={countryRowSpan}
                                            style={{ verticalAlign: "middle" }}
                                          >
                                            {country.country || "-"}
                                          </td>
                                        ) : null}

                                        <td>{e.currency || "-"}</td>
                                        <td>{e.supportMethod || "-"}</td>
                                        <td>{e.receivingEntityType || "-"}</td>
                                        <td>{e.settlementCharge || "-"}</td>
                                        <td>{e.transferLimit || "-"}</td>

                                        {countryIdx === 0 && entryIdx === 0 ? (
                                          <td
                                            rowSpan={sectionRowSpan}
                                            style={{ verticalAlign: "middle" }}
                                          >
                                            {section.bankSettlementSupportCapabilities || ""}
                                          </td>
                                        ) : null}
                                      </tr>
                                    );
                                  });
                                });
                              })}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default PayoutCommissionInformation